module.exports = __webpack_public_path__ + "img/Image_003.d27dc749.png";